import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { APP_BASE_HREF } from '@angular/common';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { WebResource, TokenCredentials } from '@azure/ms-rest-js';

import { ReportsConfigService } from 'iws-reports-config';

import { IWSLoginModule } from '@iws-ux/login';
import { IWSHeaderModule } from '@iws-ux/header';
import { ToastService } from '@iws-ux/toast';
import { ValidationSummaryService } from '@iws-ux/validation';
import { DialogService, IWSDialogModule } from '@iws-ux/dialog';
import { AuthHelperService } from '@iws-ux/auth';
import { NavigationFilterGuard } from '@iws-ux/auth';

import { routing } from './app.routing';

import { ConfigurationService } from './services/Configuration/Configuration.service';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ErrorHandlerService, IWSErrorModule } from '@iws-ux/error';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent
    ],

    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        OAuthModule.forRoot(),
        QuillModule.forRoot(),

        IWSLoginModule,
        IWSHeaderModule,
        IWSDialogModule,
        IWSErrorModule,

        routing,

        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
    //    StoreDevtoolsModule.instrument({
    //      name: 'IWS Report Config',
    //      logOnly: environment.production,
    //    })
    ],

    providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: LOCALE_ID, useValue: "en-GB" },
        { provide: 'BASE_URL', useValue: "/" },

        {
            provide: APP_INITIALIZER,
            useFactory: (configService: ConfigurationService) => () => configService.initialise(),
            deps: [ConfigurationService],
            multi: true
        },

        ValidationSummaryService,
        ErrorHandlerService,
        ConfigurationService,
        DialogService,
        ToastService,
        AuthHelperService,
        NavigationFilterGuard,

        {
            provide: ReportsConfigService,
            useFactory: (configService: ConfigurationService, oauthService: OAuthService) => {
                return new ReportsConfigService({
                    signRequest(webResource: WebResource): Promise<WebResource> {
                        const token = new TokenCredentials(oauthService.getAccessToken());
                        return token.signRequest(webResource);
                    }
                }, { baseUri: configService.config.reportConfigurationServiceEndpoint, noRetryPolicy: true });
            },
            deps: [ConfigurationService, OAuthService],
            multi: false
        }

    ],

    bootstrap: [AppComponent]
})

export class AppModule { }
